module.exports = __webpack_public_path__ + "img/category_icon5.8f89d1d9.svg";